import React from 'react'
import useStyles from './Styles'
import AccordianDetail from './accordianDetail'
import AccordionComponent from 'src/components/shared/modules/accordian/Accordian'
import { Typography } from '@mui/material'
import { pressCenterI, pressCenterAccordianI } from 'src/types/store/index'
import ReactMarkdown from 'react-markdown'
import rehypeSlug from 'rehype-slug'
import rehypeRaw from 'rehype-raw'

interface Props {
  pressCenter: pressCenterI
  pressCenterAccordian: pressCenterAccordianI[]
}
function PressCenter({ pressCenter, pressCenterAccordian }: Props) {
  const { classes } = useStyles()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const rehypeRawDec:any = rehypeRaw;
  const accordianData = pressCenterAccordian.map((item) => {
    return {
      title: item.heading,
      desc: item.description,
      component:
        item.image && item.image?.length > 0 ? (
          <AccordianDetail details={item.image} />
        ) : undefined,
    }
  })

  return (
    <div className={`${classes.pressCenter}`}>
      <div className={classes.pressCenterContent}>
        <Typography className={classes.title}>{pressCenter.heading}</Typography>
        <Typography className={classes.desc}>
          <ReactMarkdown rehypePlugins={[rehypeRawDec,rehypeSlug]}>
            {pressCenter.description}
          </ReactMarkdown>
        </Typography>
      </div>
      {accordianData && (
        <AccordionComponent accordianData={accordianData} gradient={false} />
      )}
    </div>
  )
}

export default PressCenter
